import React from "react";

interface Props {
  title: string;
  subtitle?: string;
}

const CommonHeader = ({ title, subtitle }: Props) => (
  <header className="relative w-full bg-white md:block">
    <div className="mx-auto w-full max-w-screen-md space-y-6 px-12 pt-24 text-center text-2xl md:text-3xl">
      <h1 className="text-center">{title}</h1>
      {subtitle && (
        <div
          className="content text-center text-2xl md:text-3xl md:leading-10"
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      )}
    </div>
  </header>
);

export default CommonHeader;
